import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomButton from '../Button/CustomButton';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface IPagination {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

const Pagination: React.FC<IPagination> = ({
    currentPage,
    totalPages,
    onPageChange,
    hasNextPage = true,
    hasPreviousPage = true,
}) => {
    const themeStyle = 'dark';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                mt: 4,
                mb: 2,
                width: '100%',
            }}>
            <CustomButton
                label="Previous"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={!hasPreviousPage || currentPage <= 1}
                sx={{
                    minWidth: '120px',
                    height: '40px',
                    fontSize: '0.875rem',
                    fontFamily: FONT_ENUM.MEDIUM_TEXT,
                    opacity: !hasPreviousPage || currentPage <= 1 ? 0.5 : 1,
                    '&:hover': {
                        WebkitTextFillColor: theme[themeStyle].primary_orange,
                    },
                }}
            />

            <Typography
                sx={{
                    fontFamily: FONT_ENUM.BOLD_HEADER,
                    fontSize: '1rem',
                    color: theme[themeStyle].tag_white,
                    minWidth: '60px',
                    textAlign: 'center',
                }}>
                Page {currentPage}
            </Typography>

            <CustomButton
                label="Next"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={!hasNextPage || currentPage >= totalPages}
                sx={{
                    minWidth: '120px',
                    height: '40px',
                    fontSize: '0.875rem',
                    fontFamily: FONT_ENUM.MEDIUM_TEXT,
                    opacity: !hasNextPage || currentPage >= totalPages ? 0.5 : 1,
                    '&:hover': {
                        WebkitTextFillColor: theme[themeStyle].primary_orange,
                    },
                }}
            />
        </Box>
    );
};

export default Pagination;
